export default "__VITE_ASSET__DJilJrWT__"